import React, { useEffect, useState } from "react";
import "./Industries.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useHomeSection } from "../../../../context/HomePageContext";
import { getTagsFromSection } from "../../../../services/contentApi";

const Industries = () => {
  const { section, loading } = useHomeSection("industries");
  const [stars, setStars] = useState([]);

  useEffect(() => {
    const generatedStars = [];

    for (let i = 0; i < 120; i++) {
      generatedStars.push({
        id: i,
        top: Math.floor(Math.random() * 100),
        left: Math.floor(Math.random() * 100),
        size: Math.floor(Math.random() * 3) + 1,
        opacity: Math.random(),
      });
    }

    setStars(generatedStars);
  }, []);

  if (loading || !section?.fields) return null;

  const fields = section.fields;
  const tags = getTagsFromSection(section);

  return (
    <section className="industries">
      <div className="stars">
        {stars.map((star) => (
          <span
            key={star.id}
            className="star"
            style={{
              top: `${star.top}%`,
              left: `${star.left}%`,
              width: `${star.size}px`,
              height: `${star.size}px`,
              opacity: star.opacity,
            }}
          />
        ))}
      </div>

      <div className="industries-content">
        {fields.subtitle ? (
          <CmsText
            content={fields.subtitle}
            as="p"
            className="industries-subtitle"
          />
        ) : null}

        {fields.title ? (
          <CmsText
            content={fields.title}
            as="h2"
            className="industries-title"
          />
        ) : null}

        {fields.description ? (
          <RichTextContent
            content={fields.description}
            className="industries-description"
          />
        ) : null}

        <div className="industries-tags">
          {tags.map((item, index) => (
            <div key={index} className="industry-tag">
              <CmsText content={item} as="span" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
